import { render, staticRenderFns } from "./TicketsDetailsTransactions2.vue?vue&type=template&id=91001ee2&scoped=true&"
import script from "./TicketsDetailsTransactions2.vue?vue&type=script&lang=js&"
export * from "./TicketsDetailsTransactions2.vue?vue&type=script&lang=js&"
import style0 from "./TicketsDetailsTransactions2.vue?vue&type=style&index=0&id=91001ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91001ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTooltip})
